import React, { FunctionComponent } from 'react'
import { Route, Switch, RouteComponentProps } from 'react-router-dom'

import { BannerReferrals } from '../../../pages/old'
import { Err404 } from '../../../components'

interface BannerReferralsRouterProps extends RouteComponentProps<{}> {}

const BannerReferralsRouter: FunctionComponent<BannerReferralsRouterProps> = ({
  match,
}) => (
  <Switch>
    <Route path={`${match.path}`} component={BannerReferrals} />
    <Route component={Err404} />
  </Switch>
)

export default BannerReferralsRouter
